var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocSimLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a3ea2a",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a3ea2a",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M30,7s-6.86,8.29-17.03,8.29c0,31.43,17.03,37.7,17.03,37.7,0,0,17.03-6.27,17.03-37.7-10.16,0-17.03-8.29-17.03-8.29Z",
    style: {
      fill: "none",
      stroke: "#a3ea2a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,10.48s-5.83,7.04-14.46,7.04c0,26.68,14.46,32.01,14.46,32.01,0,0,14.46-5.33,14.46-32.01-8.63,0-14.46-7.04-14.46-7.04Z",
    style: {
      fill: "none",
      stroke: "#a3ea2a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.86,20.5c5.34-.3,8.92.4,9.41,2.14.94,3.37-10.05,9.4-24.56,13.47-14.51,4.06-27.04,4.63-27.98,1.25-.6-2.14,3.61-5.35,10.49-8.45",
    style: {
      fill: "none",
      filter: "url(#outer-glow-1)",
      stroke: "#a3ea2a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.14,20.5c-5.34-.3-8.92.4-9.41,2.14-.94,3.37,10.05,9.4,24.56,13.47,14.51,4.06,27.04,4.63,27.98,1.25.6-2.14-3.61-5.35-10.49-8.45",
    style: {
      fill: "none",
      filter: "url(#outer-glow-2)",
      stroke: "#a3ea2a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocSimLogo);
export default __webpack_public_path__ + "static/media/soc-sim-logo.59eeb5767108e4a4596d30b7bf5ef301.svg";
export { ForwardRef as ReactComponent };